<script lang="ts">
    import type { createDialog } from '@melt-ui/svelte';

    export let dialog: ReturnType<typeof createDialog>;
    const {
        elements: { trigger, close, overlay, description, title, portalled, content },
        states: { open },
    } = dialog;

    function setOpen(v: boolean) {
        $open = v;
    }
</script>

<slot
    triggerEl={$trigger}
    closeEl={$close}
    overlayEl={$overlay}
    descriptionEl={$description}
    titleEl={$title}
    portalledEl={$portalled}
    contentEl={$content}
    open={$open}
    {setOpen}
/>
